import Api from './Api';

class CompanyApi extends Api {
  url = 'companies';
}

const singleton = new CompanyApi();
export default singleton;
